import { validateEnumTranslations } from '../../safety_checks';

export enum NotificationType {
  BOOKING_CONFIRMED = 'BOOKING_CONFIRMED',
  BOOKING_WAITING_CONFIRMATION = 'BOOKING_WAITING_CONFIRMATION',
  BOOKING_REMINDER = 'BOOKING_REMINDER',
  BOOKING_CANCELED_BY_PRO = 'BOOKING_CANCELED_BY_PRO',
  BOOKING_CANCELED_BY_CUSTOMER = 'BOOKING_CANCELED_BY_CUSTOMER',
  BOOKING_UPDATED = 'BOOKING_UPDATED',
  REVIEW_REQUEST = 'REVIEW_REQUEST',
  VOUCHER_PURCHASED = 'VOUCHER_PURCHASED',
  VOUCHER_GIFT_RECEIVED = 'VOUCHER_GIFT_RECEIVED',
  VOUCHER_EXPIRING = 'VOUCHER_EXPIRING',
  VOUCHER_USED = 'VOUCHER_USED',
  VOUCHER_RECHARGED = 'VOUCHER_RECHARGED',
  VOUCHER_CANCELLED = 'VOUCHER_CANCELLED',
  VOUCHER_RESTORED = 'VOUCHER_RESTORED',
  PRO_NEW_BOOKING = 'PRO_NEW_BOOKING',
  PRO_BOOKING_CANCELED = 'PRO_BOOKING_CANCELED',
  PRO_BOOKING_REMINDER = 'PRO_BOOKING_REMINDER',
  PRO_NEW_REVIEW = 'PRO_NEW_REVIEW',
  PRO_VOUCHER_SOLD = 'PRO_VOUCHER_SOLD',
  PRO_QUOTA_LOW = 'PRO_QUOTA_LOW',
  PRO_PAYMENT_RECEIVED = 'PRO_PAYMENT_RECEIVED',
  PRO_NEW_CONTACT_MESSAGE = 'PRO_NEW_CONTACT_MESSAGE',
  PRO_SUPPORT_AGENT_REPLY = 'PRO_SUPPORT_AGENT_REPLY',
  TEAM_MEMBER_INVITATION = 'TEAM_MEMBER_INVITATION',
  ACCOUNT_PASSWORD_RESET = 'ACCOUNT_PASSWORD_RESET',
  PAYMENT_REFUNDED = 'PAYMENT_REFUNDED',
  PRO_BOOKING_RESCHEDULED = 'PRO_BOOKING_RESCHEDULED',
  PRO_BILLING_PAYMENT_FAILED = 'PRO_BILLING_PAYMENT_FAILED',
  PRO_BILLING_PAYMENT_METHOD_MISSING = 'PRO_BILLING_PAYMENT_METHOD_MISSING',
  PRO_BILLING_SUSPENSION_NOTICE = 'PRO_BILLING_SUSPENSION_NOTICE',
  PRO_BILLING_SEMI_FROZEN = 'PRO_BILLING_SEMI_FROZEN',
  PRO_BILLING_PAST_DUE = 'PRO_BILLING_PAST_DUE',
  PRO_BILLING_PAYMENT_RECOVERED = 'PRO_BILLING_PAYMENT_RECOVERED',
  PRO_CUSTOMER_IMPORT_COMPLETED = 'PRO_CUSTOMER_IMPORT_COMPLETED',
  AFFILIATE_LOGIN_OTP = 'AFFILIATE_LOGIN_OTP',
  AFFILIATE_ACCOUNT_APPROVED = 'AFFILIATE_ACCOUNT_APPROVED',
  AFFILIATE_REFERRAL_SIGNUP = 'AFFILIATE_REFERRAL_SIGNUP',
  AFFILIATE_REFERRAL_SUBSCRIBED = 'AFFILIATE_REFERRAL_SUBSCRIBED',
  AFFILIATE_COMMISSION_EARNED = 'AFFILIATE_COMMISSION_EARNED',
  PRO_TRIAL_WELCOME = 'PRO_TRIAL_WELCOME',
  PRO_TRIAL_RELANCE = 'PRO_TRIAL_RELANCE',
  // Bascule v1 → v2 : le pro programme sa date depuis l'espace Cfixé, Propelsia envoie les emails.
  PRO_MIGRATION_DAY = 'PRO_MIGRATION_DAY',
  PRO_MIGRATION_DONE = 'PRO_MIGRATION_DONE',
  // Changement d'adresse email (contact de l'établissement ou connexion) : confirmation envoyée
  // à la NOUVELLE adresse, alerte + confirmation finale envoyées à l'ANCIENNE.
  EMAIL_CHANGE_CONFIRM = 'EMAIL_CHANGE_CONFIRM',
  EMAIL_CHANGE_ALERT = 'EMAIL_CHANGE_ALERT',
  EMAIL_CHANGE_DONE = 'EMAIL_CHANGE_DONE',
  /** Articles SEO (plan MAX) : sujets du mois à valider (proposition + relances J+10 / J+18). */
  PRO_SEO_TOPICS_TO_VALIDATE = 'PRO_SEO_TOPICS_TO_VALIDATE',
  /** Articles SEO : des articles rédigés attendent la relecture du pro. */
  PRO_SEO_ARTICLES_READY = 'PRO_SEO_ARTICLES_READY',
  /** Backlink du pack : l'article partenaire qui renvoie vers le site du pro est en ligne. */
  PRO_SEO_BACKLINK_PUBLISHED = 'PRO_SEO_BACKLINK_PUBLISHED',
  /** Backlink mode B : un article partenaire attend la relecture du pro (proposition + relance J+3). */
  PRO_SEO_BACKLINK_TO_REVIEW = 'PRO_SEO_BACKLINK_TO_REVIEW',
  /** Backlink mode B : pas de validation à J+7, le lien du mois est perdu. */
  PRO_SEO_BACKLINK_EXPIRED = 'PRO_SEO_BACKLINK_EXPIRED',
  /** Lien de paiement envoyé au client à la demande du pro (création ou bouton « Envoyer »). */
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  /** Promotions : une promotion active ou programmée démarre demain. */
  PRO_PROMOTION_STARTS_TOMORROW = 'PRO_PROMOTION_STARTS_TOMORROW',
  /** Promotions : 80 % du nombre maximal d'utilisations atteint (une fois par promotion). */
  PRO_PROMOTION_QUOTA_ALMOST_REACHED = 'PRO_PROMOTION_QUOTA_ALMOST_REACHED',
  /** Promotions : bilan à la fin (date de fin passée ou archivage). */
  PRO_PROMOTION_ENDED = 'PRO_PROMOTION_ENDED',
}

export const TRANSLATE_KEY_NOTIFICATION_TYPE = 'NOTIFICATION_TYPE_';

export const NotificationTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.BOOKING_CONFIRMED}`]: 'Confirmation rdv',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.BOOKING_WAITING_CONFIRMATION}`]:
      'Rdv en attente de confirmation',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.BOOKING_REMINDER}`]: 'Rappel de rdv',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.BOOKING_CANCELED_BY_PRO}`]: 'Annulation rdv par le pro',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.BOOKING_CANCELED_BY_CUSTOMER}`]:
      'Annulation rdv par le client',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.BOOKING_UPDATED}`]: 'Modification rdv',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.REVIEW_REQUEST}`]: "Demande d'avis",
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.VOUCHER_PURCHASED}`]: 'Bon cadeau acheté',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.VOUCHER_GIFT_RECEIVED}`]: 'Carte cadeau reçue',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.VOUCHER_EXPIRING}`]: 'Bon cadeau bientôt expiré',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.VOUCHER_USED}`]: 'Bon cadeau utilisé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.VOUCHER_RECHARGED}`]: 'Bon cadeau rechargé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.VOUCHER_CANCELLED}`]: 'Bon cadeau annulé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.VOUCHER_RESTORED}`]: 'Bon cadeau recrédité',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_NEW_BOOKING}`]: 'Nouveau rdv',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BOOKING_CANCELED}`]: 'Rdv annulé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BOOKING_REMINDER}`]: 'Rappel de rdv',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_NEW_REVIEW}`]: 'Nouvel avis reçu',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_VOUCHER_SOLD}`]: 'Bon cadeau vendu',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_QUOTA_LOW}`]: 'Quota faible',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_PAYMENT_RECEIVED}`]: 'Paiement reçu',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_NEW_CONTACT_MESSAGE}`]: 'Nouveau message',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_SUPPORT_AGENT_REPLY}`]: 'Réponse du support',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.TEAM_MEMBER_INVITATION}`]: "Invitation à rejoindre l'équipe",
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.ACCOUNT_PASSWORD_RESET}`]:
      'Réinitialisation du mot de passe',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PAYMENT_REFUNDED}`]: 'Paiement remboursé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BOOKING_RESCHEDULED}`]: 'Rdv déplacé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BILLING_PAYMENT_FAILED}`]: 'Échec de prélèvement',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BILLING_PAYMENT_METHOD_MISSING}`]:
      'Moyen de paiement manquant',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BILLING_SUSPENSION_NOTICE}`]: 'Préavis de suspension',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BILLING_SEMI_FROZEN}`]: 'Réservation en ligne suspendue',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BILLING_PAST_DUE}`]: 'Compte suspendu',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_BILLING_PAYMENT_RECOVERED}`]: 'Paiement régularisé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_CUSTOMER_IMPORT_COMPLETED}`]:
      'Import de clients terminé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.AFFILIATE_LOGIN_OTP}`]: 'Code de connexion affilié',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.AFFILIATE_ACCOUNT_APPROVED}`]: 'Compte affilié validé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.AFFILIATE_REFERRAL_SIGNUP}`]: 'Nouveau filleul inscrit',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.AFFILIATE_REFERRAL_SUBSCRIBED}`]: 'Filleul devenu client',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.AFFILIATE_COMMISSION_EARNED}`]: 'Nouvelle commission',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_TRIAL_WELCOME}`]: "Bienvenue (début d'essai)",
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_TRIAL_RELANCE}`]: "Relance d'essai",
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_MIGRATION_DAY}`]: 'Bascule Propelsia ce soir',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_MIGRATION_DONE}`]: 'Bascule Propelsia terminée',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.EMAIL_CHANGE_CONFIRM}`]:
      "Confirmation d'une nouvelle adresse email",
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.EMAIL_CHANGE_ALERT}`]:
      "Demande de changement d'adresse email",
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.EMAIL_CHANGE_DONE}`]: 'Adresse email modifiée',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_SEO_TOPICS_TO_VALIDATE}`]:
      'Sujets d’articles SEO à valider',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_SEO_ARTICLES_READY}`]: 'Articles SEO à relire',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_SEO_BACKLINK_PUBLISHED}`]: 'Backlink publié',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_SEO_BACKLINK_TO_REVIEW}`]: 'Article partenaire à relire',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_SEO_BACKLINK_EXPIRED}`]: 'Article partenaire non validé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PAYMENT_REQUEST}`]: 'Demande de paiement',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_PROMOTION_STARTS_TOMORROW}`]:
      'Promotion qui démarre demain',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_PROMOTION_QUOTA_ALMOST_REACHED}`]:
      'Promotion : 80 % du quota utilisé',
    [`${TRANSLATE_KEY_NOTIFICATION_TYPE}${NotificationType.PRO_PROMOTION_ENDED}`]: 'Bilan d’une promotion terminée',
  },
};

validateEnumTranslations(NotificationType, NotificationTypeTranslation, TRANSLATE_KEY_NOTIFICATION_TYPE, true);

/** Thème fonctionnel d'une notification — sert à regrouper les messages automatiques par sujet. */
export enum NotificationTheme {
  BOOKING = 'BOOKING',
  REVIEW = 'REVIEW',
  VOUCHER = 'VOUCHER',
  ACTIVITY = 'ACTIVITY',
  BILLING = 'BILLING',
  PROMOTION = 'PROMOTION',
}

export const TRANSLATE_KEY_NOTIFICATION_THEME = 'NOTIFICATION_THEME_';

export const NotificationThemeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_NOTIFICATION_THEME}${NotificationTheme.BOOKING}`]: 'Rendez-vous',
    [`${TRANSLATE_KEY_NOTIFICATION_THEME}${NotificationTheme.REVIEW}`]: 'Avis clients',
    [`${TRANSLATE_KEY_NOTIFICATION_THEME}${NotificationTheme.VOUCHER}`]: 'Bons cadeaux',
    [`${TRANSLATE_KEY_NOTIFICATION_THEME}${NotificationTheme.ACTIVITY}`]: 'Activité & paiements',
    [`${TRANSLATE_KEY_NOTIFICATION_THEME}${NotificationTheme.BILLING}`]: 'Abonnement & facturation',
    [`${TRANSLATE_KEY_NOTIFICATION_THEME}${NotificationTheme.PROMOTION}`]: 'Promotions',
  },
};

validateEnumTranslations(NotificationTheme, NotificationThemeTranslation, TRANSLATE_KEY_NOTIFICATION_THEME, true);
